module.exports = __webpack_public_path__ + "img/buessiness_yywl_c1.ff827373.png";